import styled from 'styled-components';
export const VolumeSlider = styled.div `
    display: block;
    width: 100px;
    background-color: #616264;
    position: absolute;
    bottom: 0;
    height: 4px;
    left: 8px;
`;
const PERCENT = 100;
export const VolumeLevel = styled.div.attrs(({ volume, muted }) => ({
    style: {
        width: `${!muted ? volume * PERCENT : 0}%`,
    },
})) `
    display: block;
    width: 100%;
    height: 100%;
    background-color: #fff;
    position: absolute;
    bottom: 0;
`;
export const VolumeScrubber = styled.div `
    display: block;
    width: 14px;
    height: 14px;
    background-color: #fff;
    border-radius: 14px;
    position: absolute;
    right: -5px;
    top: -5px;
`;
//# sourceMappingURL=index.js.map